export default {
	权限管理员: {
		菜单: ['主页', '人事主页', '通讯录', '注销', '系统管理.系统参数', '系统管理.职务管理', '系统管理.签核职务', '系统管理.币别管理', '系统管理.汇率管理', '系统管理.服务配置', '系统管理.节假日管理', '系统管理.开户账号管理',
			'人事管理.考勤管理.请假管理.假期管理', '人事管理.员工基本资料', '人事管理.考勤管理.请假管理.给假管理',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询', '人事管理.查询.销假查询',
			'人事管理.公告管理', '人事管理.订餐统计',
			'人事管理.考勤管理.异常管理.考勤记录', '人事管理.考勤管理.异常管理.异常考勤', , '人事管理.考勤管理.异常管理.忘刷卡申请', '人事管理.考勤管理.异常管理.忘刷卡签核',
			'人事管理.考勤管理.加班管理.加班申请', '人事管理.考勤管理.加班管理.加班签核',
			'人事管理.考勤管理.班别管理',
			'人事管理.考勤管理.请假管理.请假申请', '人事管理.考勤管理.请假管理.代理人签核', '人事管理.考勤管理.请假管理.请假签核', '人事管理.考勤管理.请假管理.司机确认', '人事管理.考勤管理.请假管理.出差报告上传',
			'人事管理.考勤管理.请假管理.销假签核', '报告管理.报告制作',
			'人事管理.考勤管理.批量特休假管理.批量特休假查询', '人事管理.考勤管理.批量特休假管理.批量特休假申请', '人事管理.考勤管理.批量特休假管理.批量特休假签核',
			'人事管理.薪资管理.调薪查询', '人事管理.薪资管理.调薪申请', '人事管理.薪资管理.调薪签核',
			'人事管理.薪资管理.月薪查询', '人事管理.薪资管理.月薪制作', '人事管理.薪资管理.月薪签核', '人事管理.薪资管理.加扣项确认', '人事管理.薪资管理.加扣项处理', '人事管理.薪资管理.加扣项查询',
			'人事管理.薪资管理.奖金查询', '人事管理.薪资管理.奖金申请', '人事管理.薪资管理.奖金签核',
			'OA管理.流程管理', 'OA管理.印章管理', 'OA管理.人事表单.人事表单查询', 'OA管理.人事表单.人事表单申请', 'OA管理.人事表单.人事表单签核', 'OA管理.IT表单.IT表单查询', 'OA管理.IT表单.IT表单申请', 'OA管理.IT表单.IT表单签核', 'OA管理.其他表单.其他表单查询', 'OA管理.其他表单.其他表单申请', 'OA管理.其他表单.其他表单签核',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.逾期报告查询', '数据查询.样品查询', '数据查询.逾期账款查询',
			'业务管理.委托申请', '业务管理.业务报价.委外金额确认', '业务管理.业务报价.业务报价', '业务管理.业务报价.报价初审', '业务管理.业务报价.报价审核', '业务管理.业务报价.报价复审',
			'业务管理.结案发送', '业务管理.结案确认', '业务管理.满意度调查', '业务管理.合同变更.合同变更申请', '业务管理.合同变更.合同变更审批', '业务管理.合同变更.合同变更修改', '业务管理.合同变更.合同修改审批', '业务管理.合同变更.合同变更查询',
			'客户管理.客户查询', '客户管理.联系记录查询', '客户管理.联系提醒', '客户管理.客户管理', '客户管理.邮件管理', '客户管理.新客户申请', '客户管理.新客户审核', '客户管理.新客户批准', '客户管理.客户信息修改申请', '客户管理.客户信息修改审核', '客户管理.客户信息修改批准', '客户管理.客户信息修改查询',
			'检测管理.工程委外确认', '检测管理.进案前主管确认', '检测管理.拍照上传', '检测管理.检前处理', '检测管理.品质管制', '检测管理.数据录入', '检测管理.数据审核', '检测管理.检测小组修改', '检测管理.试剂配制.试剂配制查询', '检测管理.试剂配制.试剂配制管理', '检测管理.试剂配制.试剂配制复核',
			'报告管理.报告编制', '报告管理.报告审核', '报告管理.报告批准', '报告管理.正式报告', '报告管理.报告变更申请', '报告管理.报告变更审批', '报告管理.报告变更核准', '报告管理.报告变更批准', '报告管理.报告变更查询',
			'样品管理.待入库', '样品管理.检测领样', '样品管理.检后还样', '样品管理.仓库中', '样品管理.退样申请', '样品管理.退样审批', '样品管理.退样确认', '样品管理.退样查询', '样品管理.销毁确认', '样品管理.待销毁', '样品管理.待退样', '样品管理.已出库', '实验室管理.测试项目',
			'实验室管理.检测方法', '实验室管理.原始记录', '实验室管理.项目分类管理', '实验室管理.项目取样信息管理', '实验室管理.项目作废申请', '实验室管理.项目作废审核', '实验室管理.项目作废批准', '实验室管理.项目作废查询', '实验室管理.设备管理',
			'采购管理.供应商管理.供应商管理', '采购管理.供应商管理.供应商新增申请', '采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改申请', '采购管理.供应商管理.供应商信息修改签核', '采购管理.供应商管理.供应商信息修改查询',
			'采购管理.采购记录', '采购管理.一级分类管理', '采购管理.耗材管理', '采购管理.评价项目', '采购管理.评价管理.评价申请', '采购管理.评价管理.退回申请', '采购管理.评价管理.审核评分', '采购管理.评价管理.意见填写', '采购管理.评价管理.评价查询', '采购管理.物料管理',
			'收费管理.委外发票管理', '收费管理.对账管理', '收费管理.开票管理.开票申请', '收费管理.开票管理.开票审批', '收费管理.开票管理.助理确认', '收费管理.开票管理.开票登记', '收费管理.开票管理.发票签收', '收费管理.开票管理.发票重开退回', '收费管理.开票管理.发票重开审批', '收费管理.开票管理.发票重开处理', '收费管理.开票管理.开票记录查询', '收费管理.到账登记', '收费管理.到账分摊', '收费管理.未核销发票', '收费管理.发票查询',
			// '品质管理.项目管理.项目申请', '品质管理.项目管理.项目审批', '品质管理.项目管理.项目方法验证', '品质管理.项目管理.方法验证确认', '品质管理.项目管理.主任验证确认', '品质管理.项目管理.申请记录查询',
			'品质管理.监督计划管理.计划制定', '品质管理.监督计划管理.计划执行', '品质管理.监督计划管理.上传监督记录', '品质管理.监督计划管理.日常监督计划查询',
			'品质管理.质量管理.制定计划', '品质管理.质量管理.执行计划', '品质管理.质量管理.完成计划', '品质管理.质量管理.质量计划查询',
			'品质管理.培训管理.培训管理', '品质管理.培训管理.开展培训', '品质管理.培训管理.培训结果', '品质管理.培训管理.培训评估', '品质管理.培训管理.培训确认', '品质管理.培训管理.培训查询',
			'报表管理.数据统计',
			'报表管理.历史报表查询',
			'OA管理.预支单.预支申请', 'OA管理.预支单.预支签核', 'OA管理.预支单.金额支付', 'OA管理.预支单.预支查询',
			'OA管理.报支单.报支申请', 'OA管理.报支单.报支签核', 'OA管理.报支单.金额支付', 'OA管理.报支单.报支查询',
			'OA管理.请购单.请购申请', 'OA管理.请购单.请购签核', 'OA管理.请购单.请购议价', 'OA管理.请购单.请购查询',
			'OA管理.采购单.待采购物品', 'OA管理.采购单.采购申请', 'OA管理.采购单.采购签核', 'OA管理.采购单.采购查询',
			'OA管理.采购单.采购验收.待验收', 'OA管理.采购单.采购验收.已验收',
			'OA管理.采购单.申请人验收', 'OA管理.采购单.采购物品查询',
			'OA管理.采购单.待入库消耗品',
			'OA管理.采购单.固定资产验收.待验收资产', 'OA管理.采购单.固定资产验收.资产验收申请', 'OA管理.采购单.固定资产验收.资产验收签核', 'OA管理.采购单.固定资产验收.设备信息录入', 'OA管理.采购单.固定资产验收.资产验收查询',
			'品质管理.方法管理.方法申请', '品质管理.方法管理.方法审批', '品质管理.方法管理.方法验证', '品质管理.方法管理.方法验证确认', '品质管理.方法管理.主任验证确认', '品质管理.方法管理.申请查询',
			'实验室管理.项目管理.项目申请', '实验室管理.项目管理.金额录入', '实验室管理.项目管理.项目初审', '实验室管理.项目管理.新增修改', '实验室管理.项目管理.项目审核', '实验室管理.项目管理.金额批准', '实验室管理.项目管理.申请查询',
			'OA管理.固定资产异动.异动申请', 'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.资产异动', 'OA管理.固定资产异动.异动查询',
			'项目管理.方法管理.方法申请', '项目管理.方法管理.方法审批', '项目管理.方法管理.方法验证',
			'项目管理.方法管理.方法验证确认', '项目管理.方法管理.主任验证确认', '项目管理.方法管理.方法申请记录查询',

			'收费管理.开票管理.重开发票查询', '收费管理.发票',

			'项目管理.项目作废管理.项目作废申请', '项目管理.项目作废管理.项目作废审核', '项目管理.项目作废管理.项目作废批准', '项目管理.项目作废管理.项目作废查询',

			'项目管理.新增/修改项目.项目申请', '项目管理.新增/修改项目.金额录入', '项目管理.新增/修改项目.项目初审',
			'项目管理.新增/修改项目.新增修改', '项目管理.新增/修改项目.项目审核', '项目管理.新增/修改项目.金额批准', '项目管理.新增/修改项目.申请查询',]

	},
	总经理: {
		菜单: ['主页', '人事主页', '注销', '人事管理.员工基本资料',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询',
			'人事管理.考勤管理.加班管理.加班签核',
			'人事管理.考勤管理.请假管理.请假签核',
			'人事管理.考勤管理.请假管理.销假签核',
			'人事管理.薪资管理.调薪查询', '人事管理.薪资管理.调薪签核',
			'人事管理.薪资管理.奖金查询', '人事管理.薪资管理.奖金签核'
		]
	},
	总经理_工程: {
		菜单: ['主页', '注销',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.逾期报告查询',
			'业务管理.业务报价.委外金额确认', '业务管理.业务报价.报价审核', '业务管理.业务报价.报价复审',
		/* 	'业务管理.结案发送', '业务管理.结案确认',  */'业务管理.合同变更.合同变更申请', '业务管理.合同变更.合同变更审批', '业务管理.合同变更.合同变更修改', '业务管理.合同变更.合同修改审批', '业务管理.合同变更.合同变更查询',
			'客户管理.客户查询', '客户管理.联系记录查询', '客户管理.联系提醒', '客户管理.客户管理', '客户管理.新客户批准', '客户管理.客户信息修改批准', '客户管理.客户信息修改查询',
			/* '检测管理.工程委外确认', */ '检测管理.进案前主管确认', '检测管理.试剂配制.试剂配制查询', '检测管理.试剂配制.试剂配制管理', '检测管理.试剂配制.试剂配制复核',
			'报告管理.报告批准', '报告管理.正式报告', '报告管理.报告变更申请', '报告管理.报告变更批准', '报告管理.报告变更查询',
			'样品管理.仓库中', /* '样品管理.退样申请', */ /* '样品管理.退样审批', */  '样品管理.销毁确认', '样品管理.待销毁', '样品管理.待退样', '样品管理.已出库',
			'实验室管理.测试项目', '实验室管理.检测方法', '实验室管理.原始记录', '实验室管理.项目取样信息管理', '项目管理.项目作废管理.项目作废批准',
			'采购管理.供应商管理.供应商管理', '采购管理.采购记录', '采购管理.耗材管理',
			/* '收费管理.委外发票管理', */ /* '收费管理.开票申请',   */'收费管理.开票管理.开票登记', '收费管理.到账登记', /* '收费管理.到账分摊', */
			// '品质管理.项目管理.项目申请', '品质管理.项目管理.项目审批', '品质管理.项目管理.项目方法验证', '品质管理.项目管理.方法验证确认', '品质管理.项目管理.主任验证确认', '品质管理.项目管理.申请记录查询',
			'品质管理.监督计划管理.计划制定', '品质管理.监督计划管理.计划执行', '品质管理.监督计划管理.上传监督记录', '品质管理.监督计划管理.日常监督计划查询',
			'品质管理.质量管理.制定计划', '品质管理.质量管理.执行计划', '品质管理.质量管理.质量计划查询',
			'品质管理.培训管理.开展培训',
			'报表管理.数据统计',
			'报表管理.历史报表查询',
			'项目管理.方法管理.方法申请', '项目管理.方法管理.方法审批', '项目管理.方法管理.方法验证确认', '项目管理.方法管理.主任验证确认', '项目管理.方法管理.方法申请记录查询',
			'项目管理.新增/修改项目.金额批准', '项目管理.新增/修改项目.申请查询',
		],
	},
	人事专员: {
		菜单: ['人事主页', '注销', '系统管理.节假日管理', '系统管理.职务管理', '系统管理.签核职务', '人事管理.员工基本资料', '人事管理.考勤管理.请假管理.假期管理', '人事管理.考勤管理.请假管理.给假管理',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询',
			'报表管理.数据统计', '人事管理.订餐统计',
			'人事管理.公告管理',
			'人事管理.考勤管理.异常管理.考勤记录', '人事管理.考勤管理.异常管理.异常考勤', '人事管理.考勤管理.异常管理.忘刷卡签核',
			'人事管理.考勤管理.加班管理.加班签核',
			'人事管理.考勤管理.请假管理.请假签核',
			'OA管理.报支单.报支签核',
			'人事管理.考勤管理.批量特休假管理.批量特休假查询', '人事管理.考勤管理.批量特休假管理.批量特休假申请',
			'人事管理.考勤管理.班别管理',
			'人事管理.薪资管理.调薪查询', '人事管理.薪资管理.调薪申请',
			'人事管理.薪资管理.月薪查询', '人事管理.薪资管理.月薪制作', '人事管理.薪资管理.加扣项处理', '人事管理.薪资管理.加扣项查询',
			'人事管理.薪资管理.奖金查询', '人事管理.薪资管理.奖金申请',],
	},
	公有权限: {
		菜单: ['主页', '注销', '人事主页', '通讯录', '人事管理.员工基本资料',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询', '人事管理.查询.销假查询',
			'人事管理.考勤管理.异常管理.异常考勤', '人事管理.考勤管理.异常管理.忘刷卡申请',
			'人事管理.考勤管理.加班管理.加班申请',
			'人事管理.考勤管理.请假管理.请假申请', '人事管理.考勤管理.请假管理.代理人签核',
			'人事管理.考勤管理.请假管理.出差报告上传',
			'人事管理.薪资管理.加扣项确认',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询',
			'OA管理.人事表单.人事表单查询', 'OA管理.人事表单.人事表单申请', 'OA管理.人事表单.人事表单签核', 'OA管理.IT表单.IT表单查询', 'OA管理.IT表单.IT表单申请', 'OA管理.IT表单.IT表单签核', 'OA管理.其他表单.其他表单查询', 'OA管理.其他表单.其他表单申请', 'OA管理.其他表单.其他表单签核',
			'OA管理.预支单.预支申请', 'OA管理.预支单.预支查询', 'OA管理.报支单.报支申请', 'OA管理.报支单.报支签核', 'OA管理.报支单.报支查询',
			'OA管理.请购单.请购申请', 'OA管理.请购单.请购查询', 'OA管理.采购单.申请人验收', 'OA管理.采购单.采购物品查询', 'OA管理.采购单.采购查询',
			'OA管理.采购单.固定资产验收.待验收资产', 'OA管理.采购单.固定资产验收.资产验收申请', 'OA管理.采购单.固定资产验收.资产验收查询',
			'OA管理.固定资产异动.异动申请', 'OA管理.固定资产异动.异动查询',
		],
	},
	课长: {
		菜单: ['人事主页', '注销',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询',
			'人事管理.考勤管理.异常管理.忘刷卡签核',
			'人事管理.考勤管理.加班管理.加班签核',
			'人事管理.考勤管理.请假管理.请假签核',
			'人事管理.考勤管理.请假管理.销假签核',
			'OA管理.请购单.请购签核',
			'OA管理.报支单.报支签核', 'OA管理.采购单.固定资产验收.资产验收签核', 'OA管理.报支单.报支查询',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',
			'采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商信息修改签核',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询',
		],
	},
	部长: {
		菜单: ['人事主页', '注销',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询',
			'人事管理.考勤管理.异常管理.忘刷卡签核',
			'人事管理.考勤管理.加班管理.加班签核',
			'人事管理.考勤管理.请假管理.请假签核',
			'人事管理.考勤管理.请假管理.销假签核',
			'OA管理.请购单.请购签核',
			'OA管理.报支单.报支签核', 'OA管理.采购单.固定资产验收.资产验收签核', 'OA管理.报支单.报支查询',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',
			'采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商信息修改签核',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询',
		],
	},
	处长: {
		菜单: ['人事主页', '注销',
			'人事管理.查询.忘刷卡申请查询', '人事管理.查询.加班查询', '人事管理.查询.假勤查询', '人事管理.查询.请假查询',
			'人事管理.考勤管理.异常管理.忘刷卡签核',
			'人事管理.考勤管理.加班管理.加班签核',
			'人事管理.考勤管理.请假管理.请假签核',
			'人事管理.考勤管理.请假管理.销假签核',
			'OA管理.请购单.请购签核',
			'OA管理.报支单.报支签核', 'OA管理.采购单.固定资产验收.资产验收签核', 'OA管理.报支单.报支查询',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',
			'采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商信息修改签核',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询',
		],
	},
	董事长: {
		菜单: ['人事主页', '注销',
			'人事管理.查询.请假查询',
			'人事管理.考勤管理.请假管理.请假签核',
			'人事管理.考勤管理.请假管理.销假签核',
		],
	},
	司机: {
		菜单: ['人事主页', '注销',
			'人事管理.考勤管理.请假管理.司机确认',
		],
	},
	行政处长: {
		菜单: ['人事主页', '注销',
			'人事管理.薪资管理.调薪查询', '人事管理.薪资管理.调薪签核',
			'人事管理.薪资管理.月薪查询', '人事管理.薪资管理.月薪签核',
			'人事管理.考勤管理.批量特休假管理.批量特休假查询', '人事管理.考勤管理.批量特休假管理.批量特休假签核',
			'人事管理.薪资管理.奖金查询', '人事管理.薪资管理.奖金签核',
			'OA管理.报支单.报支签核', 'OA管理.采购单.固定资产验收.资产验收签核', 'OA管理.报支单.报支查询',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',
		],
	},
	工程主管: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.逾期报告查询', '数据查询.样品查询',
			'检测管理.工程委外确认', '检测管理.进案前主管确认', '检测管理.拍照上传', '检测管理.检前处理', '检测管理.品质管制', '检测管理.数据录入', '检测管理.数据审核', '检测管理.检测小组修改',
			'报告管理.报告编制', '报告管理.报告审核', '报告管理.报告批准', '报告管理.正式报告', '报告管理.报告变更申请', '报告管理.报告变更审批', '报告管理.报告变更核准', '报告管理.报告变更批准', '报告管理.报告变更查询',
			'样品管理.待入库', '样品管理.检测领样', '样品管理.检后还样', '样品管理.仓库中', '样品管理.退样审批', '样品管理.退样查询', '样品管理.销毁确认', '样品管理.待销毁', '样品管理.待退样', '样品管理.已出库', '实验室管理.测试项目',
			'实验室管理.检测方法', '实验室管理.原始记录', '实验室管理.项目分类管理', '项目管理.项目作废管理.项目作废审核', '项目管理.项目作废管理.项目作废查询',
			'采购管理.耗材管理', '业务管理.合同变更.合同修改审批',
			'项目管理.新增/修改项目.项目初审', '项目管理.新增/修改项目.项目审核', '项目管理.新增/修改项目.申请查询',
		],
	},
	业务员: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.逾期报告查询', '数据查询.逾期账款查询',
			'业务管理.委托申请', '业务管理.业务报价.业务报价',
			'业务管理.结案发送', '业务管理.结案确认', '业务管理.合同变更.合同变更申请', '业务管理.合同变更.合同变更修改', '业务管理.合同变更.合同修改审批', '业务管理.合同变更.合同变更查询',
			'客户管理.客户查询', '客户管理.联系记录查询', '客户管理.联系提醒', '客户管理.客户管理', '客户管理.邮件管理', '客户管理.新客户申请',
			'报告管理.正式报告', '报告管理.报告变更申请', '报告管理.报告变更查询',
			'样品管理.退样申请',
			'收费管理.委外发票管理', '收费管理.开票管理.开票申请', '收费管理.开票管理.开票登记', '收费管理.开票管理.开票记录查询',
			'OA管理.报支单.报支签核', 'OA管理.报支单.报支查询',
			'项目管理.新增/修改项目.项目申请', '项目管理.新增/修改项目.申请查询',
		],
	},
	业务课长: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.逾期报告查询',
			'业务管理.业务报价.业务报价', '业务管理.业务报价.报价初审', '业务管理.合同变更.合同变更审批', '业务管理.合同变更.合同修改审批',
			'客户管理.邮件管理', '客户管理.客户信息修改查询',
			'收费管理.发票查询', '收费管理.开票管理.开票记录查询',
		],
	},
	工程助理: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.逾期报告查询',
			'业务管理.结案确认',
			'检测管理.拍照上传', '检测管理.检前处理',
			'报告管理.报告编制', '报告管理.报告制作', '报告管理.报告变更查询',
			'样品管理.待入库', '样品管理.仓库中', '样品管理.销毁确认', '样品管理.待销毁', '样品管理.待退样', '样品管理.已出库',
			'收费管理.委外发票管理',
			// '品质管理.项目管理.项目申请',
		],
	},
	评审专用: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.样品查询',
			'检测管理.试剂配制.试剂配制查询',
			'实验室管理.设备管理',
			'采购管理.耗材管理',
			// '品质管理.项目管理.申请记录查询',
		],
	},
	业务助理: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.逾期账款查询',
			'客户管理.新客户申请', '客户管理.客户信息修改申请', '客户管理.客户信息修改查询',
			'报告管理.正式报告',
			'收费管理.委外发票管理',
			'收费管理.对账管理', '收费管理.开票管理.助理确认', '收费管理.开票管理.发票重开退回', /* '收费管理.开票管理.发票重开处理', */ '收费管理.开票管理.发票签收', '收费管理.到账登记', '收费管理.到账分摊', '收费管理.未核销发票', '收费管理.发票查询', '收费管理.开票管理.开票记录查询',
		],
	},
	样品管理员: {
		菜单: ['主页',
			'数据查询.样品查询',
			'检测管理.拍照上传',
			'样品管理.待入库', '样品管理.仓库中', '样品管理.退样确认', '样品管理.退样查询', '样品管理.待销毁', '样品管理.待退样', '样品管理.已出库',],
	},
	业务经理: {
		菜单: ['主页',
			'业务管理.业务报价.委外金额确认', '业务管理.业务报价.报价审核', '业务管理.合同变更.合同修改审批',
			'客户管理.客户信息修改批准', '客户管理.客户信息修改查询',
		],
	},
	新客户审核: {
		菜单: ['主页',
			'客户管理.新客户审核',
		],
	},
	新客户批准: {
		菜单: ['主页',
			'客户管理.新客户批准',
		],
	},
	质量负责人: {
		菜单: ['主页',
			'检测管理.进案前主管确认',
			'报告管理.报告审核', '报告管理.报告变更核准', '业务管理.合同变更.合同修改审批',
			// '品质管理.项目管理.项目审批', , '品质管理.项目管理.申请记录查询',
			'品质管理.监督计划管理.计划制定', '品质管理.监督计划管理.上传监督记录', '品质管理.监督计划管理.日常监督计划查询',
			'品质管理.质量管理.制定计划', '品质管理.质量管理.质量计划查询',
			'项目管理.方法管理.方法审批', '项目管理.方法管理.方法申请记录查询',
		],
	},
	技术负责人: {
		菜单: ['主页',
			'检测管理.进案前主管确认',
			'报告管理.报告审核', '业务管理.合同变更.合同修改审批',
			// '品质管理.项目管理.项目审批', '品质管理.项目管理.方法验证确认', '品质管理.项目管理.申请记录查询',
			'品质管理.监督计划管理.计划执行', '品质管理.监督计划管理.上传监督记录', '品质管理.监督计划管理.日常监督计划查询',
			'品质管理.质量管理.完成计划', '品质管理.质量管理.质量计划查询',
			'品质管理.培训管理.培训管理', '品质管理.培训管理.培训结果', '品质管理.培训管理.培训评估',
			'项目管理.方法管理.方法审批', '项目管理.方法管理.方法验证确认', '项目管理.方法管理.方法申请记录查询',
		],
	},
	授权签字人: {
		菜单: ['主页',
			'报告管理.报告批准',
		],
	},
	公用领样或还样: {
		菜单: ['主页',
			'样品管理.检测领样', '样品管理.检后还样',
		],
	},
	检测工程师: {
		菜单: ['主页',
			'检测管理.检前处理', '检测管理.品质管制', '检测管理.数据录入', '检测管理.试剂配制.试剂配制管理',
			'样品管理.检测领样', '样品管理.检后还样',
			// '品质管理.项目管理.项目申请', '品质管理.项目管理.项目方法验证', '品质管理.项目管理.申请记录查询',
			'品质管理.监督计划管理.计划执行', '品质管理.监督计划管理.日常监督计划查询',
			'品质管理.质量管理.执行计划', '品质管理.质量管理.质量计划查询',
			'项目管理.方法管理.方法申请', '项目管理.方法管理.方法验证', '项目管理.方法管理.方法申请记录查询',
		],
	},
	测试项目管理: {
		菜单: ['主页',
			'实验室管理.测试项目', '实验室管理.检测方法', '实验室管理.项目分类管理', '实验室管理.项目取样信息管理', '项目管理.项目作废管理.项目作废申请', '项目管理.项目作废管理.项目作废查询',
		],
	},
	评审专用: {
		菜单: ['主页',
			'数据查询.合同查询', '数据查询.报告查询', '数据查询.样品查询',
			'检测管理.试剂配制.试剂配制查询', '检测管理.试剂配制.试剂配制管理', '检测管理.试剂配制.试剂配制复核',
			'实验室管理.设备管理',
			'采购管理.耗材管理',
			/* '品质管理.项目管理.申请记录查询', */ '项目管理.方法管理.方法申请记录查询', '项目管理.方法管理.方法申请记录查询',
		],
	},
	设备管理员: {
		菜单: ['主页',
			'实验室管理.设备管理',
			'OA管理.采购单.固定资产验收.设备信息录入',
		],
	},
	采购人: {
		菜单: ['主页',
			'采购管理.供应商管理.供应商管理', '采购管理.供应商管理.供应商新增申请', '采购管理.供应商管理.供应商信息修改申请',
			'采购管理.评价管理.评价申请', '采购管理.评价管理.退回申请', '采购管理.采购记录', '采购管理.评价项目', '采购管理.评价管理.评价查询',
			'OA管理.请购单.请购签核',
			'OA管理.采购单.待采购物品', 'OA管理.采购单.采购申请', 'OA管理.采购单.采购验收.待验收', 'OA管理.采购单.采购验收.已验收', 'OA管理.采购单.采购物品查询',
			'OA管理.采购单.固定资产验收.资产验收签核',
			'采购管理.物料管理'
		],
	},
	耗材管理员: {
		菜单: ['主页',
			'采购管理.耗材管理', 'OA管理.采购单.待入库消耗品',
		],
	},
	监督员: {
		菜单: ['主页',
			'检测管理.品质管制',
			// '品质管理.项目管理.申请记录查询',
			'品质管理.监督计划管理.计划制定', '品质管理.监督计划管理.计划执行', '品质管理.监督计划管理.日常监督计划查询',
			'品质管理.质量管理.制定计划',
			'品质管理.培训管理.培训管理',
		],
	},
	文管中心: {
		菜单: ['主页',
			'品质管理.监督计划管理.日常监督计划查询',
			'项目管理.新增/修改项目.新增修改', '项目管理.新增/修改项目.申请查询',
		],
	},
	讲师: {
		菜单: ['主页',
			'品质管理.培训管理.开展培训',
		],
	},
	工程人员: {
		菜单: ['主页',
			'检测管理.试剂配制.试剂配制查询', '检测管理.试剂配制.试剂配制管理',
			// '品质管理.项目管理.项目申请', '品质管理.项目管理.项目审批',
			'项目管理.方法管理.方法申请', '项目管理.方法管理.方法验证确认', '项目管理.方法管理.方法申请记录查询',
			'项目管理.新增/修改项目.项目申请', '项目管理.新增/修改项目.申请查询',
		]
	},
	业务主管: {
		菜单: [
			'数据查询.逾期账款查询',
			'客户管理.客户管理', '客户管理.新客户申请',
			'报告管理.正式报告', '报告管理.报告变更审批', '报告管理.报告变更查询',
			'收费管理.开票管理.开票审批', '收费管理.开票管理.开票记录查询',
			'项目管理.新增/修改项目.金额录入', '项目管理.新增/修改项目.申请查询', '实验室管理.测试项目'
		]
	},
	行政课长: {
		菜单: [
			'OA管理.报支单.报支签核', 'OA管理.报支单.报支查询',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',
		]
	},
	行政部长: {
		菜单: [
			'OA管理.报支单.报支签核', 'OA管理.报支单.报支查询',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',
		]
	},
	行政经办人: {
		菜单: [
			// 'OA管理.固定资产异动.资产异动',
		]
	},
	财务课长: {
		菜单: ['OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询', '系统管理.开户账号管理', '收费管理.发票',]
	},
	财务课长_工程: {
		菜单: ['收费管理.开票管理.发票重开审批', '收费管理.开票管理.开票记录查询',
			'采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商信息修改签核',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询',
			'收费管理.开票管理.重开发票查询', '收费管理.发票查询', '收费管理.发票',
		]
	},
	财务部长: {
		菜单: ['OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询', '系统管理.开户账号管理', '收费管理.发票',]
	},
	财务部长_工程: {
		菜单: ['收费管理.开票管理.发票重开审批', '收费管理.开票管理.开票记录查询',
			'采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商信息修改签核',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询', '收费管理.发票',]
	},
	财务处长: {
		菜单: ['OA管理.请购单.请购签核',
			'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询', 'OA管理.采购单.采购物品查询',
			'报表管理.数据统计',
			'报表管理.历史报表查询', '系统管理.开户账号管理', '收费管理.发票',]
	},
	财务处长_工程: {
		菜单: ['收费管理.开票管理.发票重开审批', '收费管理.开票管理.开票记录查询',
			'报表管理.数据统计',
			'报表管理.历史报表查询',
			'采购管理.供应商管理.供应商新增签核', '采购管理.供应商管理.供应商信息修改签核',
			'采购管理.供应商管理.供应商新增查询', '采购管理.供应商管理.供应商信息修改查询',
			'收费管理.开票管理.重开发票查询', '收费管理.发票查询', '收费管理.发票',
		]
	},
	财务经办人: {
		菜单: [
			'系统管理.币别管理', '系统管理.汇率管理',
			'OA管理.请购单.请购签核',
			'OA管理.预支单.金额支付', 'OA管理.报支单.金额支付', 'OA管理.采购单.采购物品查询', 'OA管理.采购单.固定资产验收.资产验收签核',
			'OA管理.固定资产异动.资产异动', 'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询', 'OA管理.报支单.报支查询', '系统管理.开户账号管理', '收费管理.发票',]
	},
	财务经办人_工程: {
		菜单: [
			'系统管理.币别管理', '系统管理.汇率管理',
			'收费管理.开票管理.开票登记', '收费管理.开票管理.开票记录查询',
			'数据查询.逾期账款查询',
			'收费管理.开票管理.重开发票查询', '收费管理.发票查询', '收费管理.发票',
		]
	},
	集团财务长: {
		菜单: ['报表管理.数据统计',
			'报表管理.历史报表查询', '收费管理.发票',]
	},
	资讯课长: {
		菜单: ['OA管理.采购单.采购物品查询', 'OA管理.请购单.请购签核']
	},
	资讯部长: {
		菜单: ['OA管理.采购单.采购物品查询', 'OA管理.请购单.请购签核']
	},
	资讯处长: {

	},
	资讯经办人: {

	},
	供应商审核人: {
		菜单: ['采购管理.评价管理.审核评分', '采购管理.评价管理.评价查询']
	},
	实验室主任: {
		菜单: [
			'采购管理.评价管理.意见填写', '采购管理.评价管理.评价查询', '业务管理.合同变更.合同修改审批',
			'项目管理.方法管理.方法审批', '项目管理.方法管理.主任验证确认', '项目管理.方法管理.方法申请记录查询',
		]
	},
	实验室主任_工程: {
		菜单: [
			'采购管理.评价管理.意见填写', '采购管理.评价管理.评价查询', '业务管理.合同变更.合同修改审批',
			'项目管理.方法管理.方法审批', '项目管理.方法管理.主任验证确认', '项目管理.方法管理.方法申请记录查询',
			'报告管理.报告变更批准',
		]
	},
	OA流程管理: {
		菜单: ['OA管理.流程管理']
	},
	预支签核: {
		菜单: ['OA管理.预支单.预支签核', 'OA管理.预支单.预支查询']
	},
	报支签核: {
		菜单: ['OA管理.报支单.报支签核', 'OA管理.报支单.报支查询']
	},
	台湾管理处副总: {
		菜单: ['OA管理.预支单.预支签核', 'OA管理.预支单.预支查询', 'OA管理.报支单.报支签核', 'OA管理.报支单.报支查询']
	},
	台湾采购人: {
		菜单: ['OA管理.请购单.请购议价', 'OA管理.采购单.采购物品查询']
	},
	请购签核: {
		菜单: ['OA管理.请购单.请购签核', 'OA管理.采购单.采购物品查询']
	},
	采购签核: {
		菜单: ['OA管理.采购单.采购签核', 'OA管理.采购单.采购查询']
	},
	资产保管人: {
		菜单: ['OA管理.固定资产异动.异动申请', 'OA管理.固定资产异动.异动签核', 'OA管理.固定资产异动.异动查询',]
	},
	业务部长: {
		菜单: ['收费管理.开票管理.发票重开审批', '收费管理.开票管理.开票记录查询', '业务管理.业务报价.委外金额确认', '客户管理.客户信息修改审核', '客户管理.客户信息修改查询',]
	},
	业务处长: {
		菜单: ['收费管理.开票管理.发票重开审批', '业务管理.合同变更.合同变更审批', '收费管理.开票管理.开票记录查询',]
	},
	满意度调查员: {
		菜单: ['业务管理.满意度调查',]
	},
	总部人事专员: {
		菜单: ['人事管理.员工基本资料']
	},
	报价初审: {
		菜单: ['业务管理.业务报价.报价初审']
	},
	印章管理员: {
		菜单: ['OA管理.印章管理']
	}
}